
<!-- Event Skeleton Loader -->
<div *ngIf="isLoadingReservation">
    <div class="bg-[var(--tertiary)] py-12">
      <div class="container-padding mx-auto max-w-screen-desktop">
        <div class="flex flex-col mobile-m:flex-row mobile-m:justify-between mobile-m:items-center">
          <div class="w-1/2 mobile-m:w-1/3">
            <app-skeleton dimensions="h-10 w-full"></app-skeleton>
          </div>
          <div class="w-1/3 mobile-m:w-1/4 mt-5 mobile-m:mt-0">
            <app-skeleton dimensions="h-6 w-full"></app-skeleton>
          </div>
        </div>
      </div>
    </div>
  
    <div class="bg-[var(--light-grey)] py-12">
      <div class="container-padding mx-auto max-w-screen-desktop">
        <div class="py-6">
          <div class="flex flex-col">
            <div class="grid mobile-m:grid-cols-2 grid-cols-1 gap-8">
              <div class="col-span-1 flex flex-col justify-between gap-8">
                <div class="flex mobile-m:flex-row flex-col justify-between w-full">
                  <div>
                    <!-- Date skeleton -->
                    <div class="w-full mobile-m:w-40">
                      <app-skeleton dimensions="h-4 w-full mb-2"></app-skeleton>
                    </div>
                    
                    <!-- Price skeleton -->
                    <div class="w-full mobile-m:w-32">
                      <app-skeleton dimensions="h-8 w-full"></app-skeleton>
                    </div>
                  </div>
                  
                  <!-- Button skeleton -->
                  <div class="w-full mobile-m:w-40">
                    <app-skeleton dimensions="h-10 w-full"></app-skeleton>
                  </div>
                </div>
                
                <!-- Image skeleton -->
                <div class="w-full">
                  <app-skeleton dimensions="h-[378px] w-full"></app-skeleton>
                </div>
              </div>
              
              <div class="col-span-1">
                <!-- Location title skeleton -->
                <div class="w-full mobile-m:w-40">
                  <app-skeleton dimensions="h-8 w-full mb-4"></app-skeleton>
                </div>
                
                <!-- Map skeleton -->
                <div class="w-full">
                  <app-skeleton dimensions="tablet:h-[450px] mobile-m:h-[370px] mobile-[320px] h-[270px] w-full"></app-skeleton>
                </div>
              </div>
            </div>
            
            <div class="mt-8">
              <!-- Description title skeleton -->
              <div class="w-full mobile-m:w-40">
                <app-skeleton dimensions="h-8 w-full mb-4"></app-skeleton>
              </div>
              
              <!-- Description content skeleton -->
              <div class="w-full">
                <app-skeleton dimensions="h-4 w-full mb-2"></app-skeleton>
                <app-skeleton dimensions="h-4 w-full mb-2"></app-skeleton>
                <div class="w-full mobile-m:w-3/4">
                  <app-skeleton dimensions="h-4 w-full"></app-skeleton>
                </div>
              </div>
            </div>
          </div>
  
          <div class="w-[var(-webkit-fill-available)] h-[8px] mx-[8px] mobile-m:block hidden mt-16" style="border-top:1px dotted var(--black)"></div>
  
          <div class="mt-8">
            <!-- Participants title skeleton -->
            <div class="w-full mobile-m:w-64">
              <app-skeleton dimensions="h-8 w-full mb-4"></app-skeleton>
            </div>
            
            <!-- Participants grid skeleton -->
            <div class="grid tablet:grid-cols-8 mobile-m:grid-cols-6 mobile:grid-cols-4 grid-cols-2 gap-x-2 gap-y-12 w-full">
              <div class="w-full h-full" *ngFor="let i of [1,2,3,4,5,6,7,8]">
                <div class="w-full aspect-square bg-gray-300 rounded animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Reservation Content -->
  <div *ngIf="!isLoadingReservation && reservation">

    <div class="bg-[var(--tertiary)] py-12 mb-8">
        <div class="container-padding mx-auto max-w-screen-desktop">
          <h1 class="uppercase text-[var(--beige)] text-[40px]/[40px] font-normal mobile-m:text-left text-center">{{ 'reservation.title' | translate }} #{{reservation.locator}}</h1>
        </div>
    </div>
    
    <div class="pb-12 min-h-screen">
      <div class="container-padding mx-auto max-w-screen-desktop">
        
        <!-- Back Link -->
        <a [routerLink]="['/reservations']" 
            class="flex items-center justify-left gap-2 group cursor-pointer transition-all duration-200 mb-6 text-[var(--black)] hover:opacity-80">
            <fa-icon [icon]="faArrowLeft" class="transform group-hover:-translate-x-1.5 transition-transform duration-200"></fa-icon>
            <span class="text-sm font-medium">{{ 'reservation.backToReservations' | translate }}</span>
        </a>

        <!-- Header Card -->
        <div class="bg-white rounded-2xl shadow-lg p-6 mb-8 border border-4 border-[var(--black)]">
            <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                <div>
                    <!-- <h1 class="uppercase text-[var(--black)] text-3xl font-bold">Reserva: {{reservation.locator}}</h1> -->
                    <div class="flex flex-wrap gap-4 mt-2 text-[var(--dark-grey)]">
                        <span class="flex items-center gap-2">
                             <fa-icon [icon]="faCalendarAlt"></fa-icon>
                            {{ 'reservation.reservedOn' | translate }} {{ reservation.createdAt | date: 'dd MMM yyyy' }}
                        </span>
                        <span>•</span>
                         <span class="font-semibold">{{ reservation.items.length }} {{ 'reservation.items' | translate }}</span>
                    </div>
                </div>
                
                <div class="flex flex-col items-end">
                    <p class="text-sm text-[var(--dark-grey)] uppercase font-semibold">{{ 'reservation.totalPaid' | translate }}</p>
                    <p class="text-[var(--secondary)] text-3xl font-bold">{{ reservation.total | currency }}</p>
                </div>
            </div>
        </div>


        <!-- Items List (Accordion) -->
        <div class="space-y-4">
            <div *ngFor="let item of reservation.items; let i = index" 
                 class="bg-white rounded-xl shadow-sm hover:shadow-md border border-gray-100 transition-all duration-300 overflow-hidden">
                
                <!-- Accordion Header (Simple) -->
                <div class="p-6 cursor-pointer hover:bg-gray-50 transition-colors" (click)="toggleItem(i)">
                    <div class="flex justify-between items-center">
                        <div class="flex-1">
                            <div class="flex flex-col md:flex-row md:items-center gap-2 md:gap-4">
                                <h3 class="uppercase text-[var(--black)] text-xl font-bold">
                                    {{ item.typeId === 1 ? item.event?.title : ('reservation.customRoute' | translate) }}
                                </h3>
                                <div *ngIf="item.isPast" class="inline-flex">
                                    <span class="bg-gray-200 text-gray-600 text-xs px-2 py-1 rounded-full uppercase font-bold">{{ 'reservation.finished' | translate }}</span>
                                </div>
                            </div>
                           
                            <div class="flex flex-wrap gap-x-6 gap-y-1 mt-1 text-sm text-[var(--dark-grey)]">
                                <p>{{ 'reservation.visitor' | translate }} <span class="font-semibold text-[var(--black)]">{{ item.visitorName }}</span></p>
                                <p>{{ 'reservation.date' | translate }} <span class="font-semibold text-[var(--black)]">{{ (item.typeId === 1 ? item.event?.date : item.endDate) | date: "dd MMM yyyy" }}</span></p>
                                <p *ngIf="item.visits && item.visits.length > 0">
                                    {{ 'reservation.visited' | translate }} <span class="font-semibold text-[var(--secondary)]">{{ item.visits.length }}</span>
                                </p>
                            </div>
                            <!-- Participantes con indicador de visitado -->
                            <div class="flex flex-wrap gap-1.5 mt-2">
                                <ng-container *ngIf="item.typeId === 1">
                                    <span *ngFor="let eventBranch of item.event?.eventBranches"
                                          class="flex items-center gap-1 text-[11px] font-medium px-2 py-1 rounded-full"
                                          [ngClass]="isBranchVisited(item, eventBranch.branchId) ? 'text-white bg-[var(--secondary)]' : 'text-[var(--black)] bg-[var(--light-grey)]'">
                                        <span class="w-1.5 h-1.5 rounded-full flex-shrink-0"
                                              [ngClass]="isBranchVisited(item, eventBranch.branchId) ? 'bg-white' : 'bg-[var(--dark-orange)]'"></span>
                                        {{ eventBranch.branch?.brewery?.name }}
                                        <fa-icon *ngIf="isBranchVisited(item, eventBranch.branchId)" [icon]="faQrcode" class="ml-1 text-[10px]"></fa-icon>
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="item.typeId === 2">
                                    <span *ngFor="let branch of item.branches"
                                          class="flex items-center gap-1 text-[11px] font-medium px-2 py-1 rounded-full"
                                          [ngClass]="isBranchVisited(item, branch.id) ? 'text-white bg-[var(--secondary)]' : 'text-[var(--black)] bg-[var(--light-grey)]'">
                                        <span class="w-1.5 h-1.5 rounded-full flex-shrink-0"
                                              [ngClass]="isBranchVisited(item, branch.id) ? 'bg-white' : 'bg-[var(--dark-orange)]'"></span>
                                        {{ branch.brewery.name }}
                                        <fa-icon *ngIf="isBranchVisited(item, branch.id)" [icon]="faQrcode" class="ml-1 text-[10px]"></fa-icon>
                                    </span>
                                </ng-container>
                            </div>
                        </div>

                        <div class="flex items-center gap-4">
                             <span class="text-xl font-bold text-[var(--secondary)]">{{(item.total) | currency}}</span>
                             <div class="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-[var(--black)] transition-transform duration-300"
                                  [ngClass]="{'rotate-180': expandedItemIndex === i}">
                                 <fa-icon [icon]="faChevronDown"></fa-icon>
                             </div>
                        </div>
                    </div>
                </div>

                <!-- Accordion Body -->
                <div *ngIf="expandedItemIndex === i" class="border-t border-[var(--grey)] bg-white">
                    <div class="px-6 md:px-8 py-6 flex flex-col gap-6">

                        <!-- ═══ Event type: 2-column layout (info+image | map) ═══ -->
                        <ng-container *ngIf="item.typeId === 1">
                          <div class="grid grid-cols-1 tablet:grid-cols-2 gap-6 tablet:items-stretch">
                            <!-- Left: meta + image -->
                            <div class="flex flex-col gap-4">
                              <!-- Meta row: fecha · ver QR -->
                              <div class="flex flex-wrap items-center justify-between gap-3">
                                <div class="flex flex-wrap items-center gap-4 text-sm text-[var(--dark-grey)]">
                                  <span class="flex items-center gap-1.5">
                                    <fa-icon [icon]="faCalendarAlt"></fa-icon>
                                    {{ 'reservation.validUntil' | translate }}
                                    <strong class="text-[var(--black)]">
                                      {{ item.event?.date | date: "dd MMM yyyy" }}
                                    </strong>
                                  </span>
                                </div>
                                <div class="flex items-center gap-2">
                                  <button
                                    *ngIf="reservation.statusId == 2 && item.qr && item.qr?.qrCode && !item.isPast"
                                    (click)="openQRModal(item)"
                                    class="flex items-center gap-2 px-4 py-2 rounded-full bg-[var(--secondary)] text-white font-bold text-[12px] uppercase shadow-[0_4px_0_0_var(--dark-orange)] hover:shadow-[0_6px_0_0_var(--dark-orange)] hover:-translate-y-1 active:translate-y-1 active:shadow-[0_2px_0_0_var(--dark-orange)] transition-all whitespace-nowrap">
                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                      <path stroke-linecap="round" stroke-linejoin="round" d="M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM17 17h1v1h-1zM14 14h1v1h-1zM20 14h1v1h-1zM14 20h1v1h-1zM20 20h1v1h-1z"/>
                                    </svg>
                                    {{ 'reservation.viewQR' | translate }}
                                  </button>
                                  <span *ngIf="item.isPast"
                                    class="text-xs font-bold uppercase bg-[var(--light-grey)] text-[var(--dark-grey)] px-3 py-1 rounded-full">
                                    {{ 'reservation.finished' | translate }}
                                  </span>
                                </div>
                              </div>
                              <!-- Event image -->
                              <div class="h-[300px] rounded-xl overflow-hidden shadow-sm">
                                <img [src]="item.event?.imageUrl" [alt]="item.event?.title" class="w-full h-full object-cover">
                              </div>
                            </div>

                            <!-- Right: map (stretches to match) -->
                            <div class="flex flex-col">
                              <div class="flex-1 min-h-[280px] rounded-xl overflow-hidden shadow-sm border border-[var(--grey)]">
                                <app-map
                                  [mapHeight]="'100%'"
                                  [eventBranches]="item.event?.eventBranches || []"
                                  [customCoords]="item.event?.locationType == 2 ? [item.event!.latitude, item.event!.longitude] : undefined"
                                  [customTitle]="item.event?.locationType == 2 ? item.event!.title : undefined"
                                  [customLogoUrl]="item.event?.locationType == 2 ? item.event!.imageUrl : undefined"
                                  [customGooglePlaceId]="item.event?.locationType == 2 ? item.event!.google_place_id : undefined"
                                  class="w-full h-full block">
                                </app-map>
                              </div>
                            </div>
                          </div>
                        </ng-container>

                        <!-- ═══ Event type sections ═══ -->
                        <ng-container *ngIf="item.typeId === 1">

                          <!-- Descripción -->
                          <div class="border-t border-[var(--grey)] pt-5">
                            <p class="text-[11px] uppercase font-bold tracking-widest text-[var(--dark-grey)] mb-2">{{ 'reservation.description' | translate }}</p>
                            <p [style.white-space]="'pre-line'" class="text-[15px] text-[var(--black)] leading-relaxed">
                              {{ item.event?.description }}
                            </p>
                          </div>

                          <!-- Quiénes participan -->
                          <div *ngIf="item.event?.eventBranches?.length" class="border-t border-[var(--grey)] pt-5">
                            <p class="text-[11px] uppercase font-bold tracking-widest text-[var(--dark-grey)] mb-3">{{ 'event.participants' | translate }}</p>
                            <div class="flex flex-wrap gap-3">
                              <div *ngFor="let eventBranch of item.event?.eventBranches" class="w-16 h-16 tablet:w-20 tablet:h-20">
                                <app-brewery-logo [brewery]="eventBranch.branch?.brewery"></app-brewery-logo>
                              </div>
                            </div>
                          </div>

                          <!-- Horarios -->
                          <ng-container *ngIf="item.event?.eventBranches?.length && eventHasAnySchedules(item.event!.eventBranches!)">
                            <div class="border-t border-[var(--grey)] pt-5">
                              <p class="text-[10px] uppercase font-bold tracking-widest text-[var(--dark-grey)] mb-1 flex items-center gap-1.5">
                                <fa-icon [icon]="faClock" class="text-[var(--dark-orange)]"></fa-icon>
                                {{ 'reservation.schedules' | translate }}
                              </p>
                              <div class="flex flex-col">
                                <ng-container *ngFor="let eventBranch of item.event?.eventBranches">
                                  <ng-container *ngIf="branchHasSchedules(eventBranch.branch)">
                                    <button class="w-full flex items-center justify-between py-2.5 text-left group"
                                            (click)="toggleSchedule(eventBranch.branchId)">
                                      <span class="text-[12px] font-semibold uppercase tracking-wide text-[var(--black)]">{{ eventBranch.branch?.brewery?.name }}</span>
                                      <span class="text-[10px] uppercase tracking-widest text-[var(--dark-grey)] group-hover:text-[var(--black)] transition-colors">
                                        {{ expandedScheduleBranchId === eventBranch.branchId ? ('schedule.hide' | translate) : ('schedule.viewHours' | translate) }}
                                      </span>
                                    </button>
                                    <div *ngIf="expandedScheduleBranchId === eventBranch.branchId" class="pb-3">
                                      <app-branch-schedule
                                        [schedules]="eventBranch.branch?.schedules || []"
                                        [branchAddress]="eventBranch.branch?.address || ''"
                                        [showDrinkHoppingTip]="true">
                                      </app-branch-schedule>
                                    </div>
                                    <div class="w-full h-px bg-[var(--grey)]"></div>
                                  </ng-container>
                                </ng-container>
                              </div>
                            </div>
                          </ng-container>

                          <!-- Sucursales visitadas -->
                          <div *ngIf="item.visits && item.visits.length > 0" class="border-t border-[var(--grey)] pt-5">
                            <p class="text-[11px] uppercase font-bold tracking-widest text-[var(--dark-grey)] mb-3">{{ 'reservation.visitedBranches' | translate }}</p>
                            <div class="flex flex-col gap-2">
                              <div *ngFor="let visit of item.visits" class="flex items-center gap-2 text-[13px]">
                                <fa-icon [icon]="faQrcode" class="text-[var(--secondary)]"></fa-icon>
                                <span class="font-semibold text-[var(--black)]">{{ visit.branch.brewery.name }}</span>
                                <span class="text-[var(--dark-grey)]">-</span>
                                <span class="text-[var(--dark-grey)]">{{ visit.createdAt | date: 'dd MMM, HH:mm' }}</span>
                              </div>
                            </div>
                          </div>

                        </ng-container>

                        <!-- ═══ Custom type: 2-column layout (info+mascot | map) ═══ -->
                        <ng-container *ngIf="item.typeId === 2">
                          <div class="grid grid-cols-1 tablet:grid-cols-2 gap-6 tablet:items-stretch">
                            <!-- Left: meta + mascot -->
                            <div class="flex flex-col gap-4">
                              <!-- Meta row: fecha · ver QR -->
                              <div class="flex flex-wrap items-center justify-between gap-3">
                                <div class="flex flex-wrap items-center gap-4 text-sm text-[var(--dark-grey)]">
                                  <span class="flex items-center gap-1.5">
                                    <fa-icon [icon]="faCalendarAlt"></fa-icon>
                                    {{ 'reservation.validUntil' | translate }}
                                    <strong class="text-[var(--black)]">
                                      {{ item.endDate | date: "dd MMM yyyy" }}
                                    </strong>
                                  </span>
                                </div>
                                <div class="flex items-center gap-2">
                                  <button
                                    *ngIf="reservation.statusId == 2 && item.qr && item.qr?.qrCode && !item.isPast"
                                    (click)="openQRModal(item)"
                                    class="flex items-center gap-2 px-4 py-2 rounded-full bg-[var(--secondary)] text-white font-bold text-[12px] uppercase shadow-[0_4px_0_0_var(--dark-orange)] hover:shadow-[0_6px_0_0_var(--dark-orange)] hover:-translate-y-1 active:translate-y-1 active:shadow-[0_2px_0_0_var(--dark-orange)] transition-all whitespace-nowrap">
                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                      <path stroke-linecap="round" stroke-linejoin="round" d="M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM17 17h1v1h-1zM14 14h1v1h-1zM20 14h1v1h-1zM14 20h1v1h-1zM20 20h1v1h-1z"/>
                                    </svg>
                                    {{ 'reservation.viewQR' | translate }}
                                  </button>
                                  <span *ngIf="item.isPast"
                                    class="text-xs font-bold uppercase bg-[var(--light-grey)] text-[var(--dark-grey)] px-3 py-1 rounded-full">
                                    {{ 'reservation.finished' | translate }}
                                  </span>
                                </div>
                              </div>
                              <!-- Mascot image -->
                              <div class="h-[300px] rounded-xl overflow-hidden shadow-sm bg-[var(--light-grey)] flex items-center justify-center">
                                <img src="assets/mascota.webp" alt="DrinkHopping" class="h-full object-contain p-4">
                              </div>
                            </div>

                            <!-- Right: map (stretches to match) -->
                            <div class="flex flex-col">
                              <div class="flex-1 min-h-[280px] rounded-xl overflow-hidden shadow-sm border border-[var(--grey)]">
                                <app-map
                                  [mapHeight]="'100%'"
                                  [branches]="item.branches || []"
                                  class="w-full h-full block">
                                </app-map>
                              </div>
                            </div>
                          </div>
                        </ng-container>

                        <!-- ═══ Custom type sections ═══ -->
                        <ng-container *ngIf="item.typeId === 2">

                          <!-- Selecciones (productos) -->
                          <div class="border-t border-[var(--grey)] pt-5">
                            <p class="text-[11px] uppercase font-bold tracking-widest text-[var(--dark-grey)] mb-1">{{ 'reservation.yourSelections' | translate }}</p>
                            <p class="text-[13px] text-[var(--dark-grey)] mb-4">{{ 'reservation.chooseProduct' | translate }}</p>

                            <div class="flex flex-col divide-y divide-[var(--grey)]">
                              <div *ngFor="let selection of item.selections" class="py-3 first:pt-0 last:pb-0">
                                <div class="flex items-start gap-3">
                                  <span class="mt-1 w-2 h-2 rounded-full flex-shrink-0"
                                        [ngClass]="isSelectionVisited(item, selection.branchId, selection.categoryId) ? 'bg-[var(--secondary)]' : 'bg-gray-300'"></span>
                                  <div class="flex-1 min-w-0">
                                    <div class="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
                                      <span class="font-semibold text-[14px] text-[var(--black)]">{{ selection.branch.brewery.name }}</span>
                                      <span class="text-[12px] text-[var(--dark-grey)]">{{ selection.branch.address }}</span>
                                      <fa-icon *ngIf="isSelectionVisited(item, selection.branchId, selection.categoryId)" 
                                               [icon]="faQrcode" 
                                               class="text-[var(--secondary)] text-[12px]"></fa-icon>
                                    </div>
                                    <div class="flex flex-wrap items-center gap-1.5 mt-1.5">
                                      <span class="text-[11px] font-bold uppercase text-[var(--secondary)]">{{ selection.category.name }}:</span>
                                      <span *ngFor="let product of selection.category.products"
                                            class="text-[11px] text-[var(--black)] px-2 py-0.5 rounded-full"
                                            [ngClass]="isProductSelected(item, selection.branchId, selection.categoryId, product.id) ? 'bg-[var(--secondary)] text-white font-bold' : 'bg-[var(--light-grey)]'">
                                        {{ product.name }}
                                        <fa-icon *ngIf="isProductSelected(item, selection.branchId, selection.categoryId, product.id)" 
                                                 [icon]="faQrcode" 
                                                 class="ml-1 text-[10px]"></fa-icon>
                                      </span>
                                      <span *ngIf="!selection.category.products?.length"
                                            class="text-[11px] italic text-[var(--dark-grey)]">{{ 'reservation.noProducts' | translate }}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <p class="text-[11px] text-[var(--dark-grey)] italic mt-4 flex items-center gap-1">
                              <fa-icon [icon]="faInfoCircle"></fa-icon>
                              {{ 'reservation.availabilityNote' | translate }}
                            </p>
                          </div>

                          <!-- Quiénes participan -->
                          <div *ngIf="item.branches?.length" class="border-t border-[var(--grey)] pt-5">
                            <p class="text-[11px] uppercase font-bold tracking-widest text-[var(--dark-grey)] mb-3">{{ 'event.participants' | translate }}</p>
                            <div class="flex flex-wrap gap-3">
                              <div *ngFor="let branch of item.branches" class="w-16 h-16 tablet:w-20 tablet:h-20">
                                <app-brewery-logo [brewery]="branch.brewery"></app-brewery-logo>
                              </div>
                            </div>
                          </div>

                          <!-- Horarios -->
                          <ng-container *ngIf="item.branches?.length && branchesHaveAnySchedules(item.branches!)">
                            <div class="border-t border-[var(--grey)] pt-5">
                              <p class="text-[10px] uppercase font-bold tracking-widest text-[var(--dark-grey)] mb-1 flex items-center gap-1.5">
                                <fa-icon [icon]="faClock" class="text-[var(--dark-orange)]"></fa-icon>
                                {{ 'reservation.schedules' | translate }}
                              </p>
                              <div class="flex flex-col">
                                <ng-container *ngFor="let branch of item.branches">
                                  <ng-container *ngIf="branchHasSchedules(branch)">
                                    <button class="w-full flex items-center justify-between py-2.5 text-left group"
                                            (click)="toggleSchedule(branch.id)">
                                      <span class="text-[12px] font-semibold uppercase tracking-wide text-[var(--black)]">{{ branch.brewery.name }}</span>
                                      <span class="text-[10px] uppercase tracking-widest text-[var(--dark-grey)] group-hover:text-[var(--black)] transition-colors">
                                        {{ expandedScheduleBranchId === branch.id ? ('schedule.hide' | translate) : ('schedule.viewHours' | translate) }}
                                      </span>
                                    </button>
                                    <div *ngIf="expandedScheduleBranchId === branch.id" class="pb-3">
                                      <app-branch-schedule
                                        [schedules]="branch.schedules || []"
                                        [branchAddress]="branch.address"
                                        [showDrinkHoppingTip]="true">
                                      </app-branch-schedule>
                                    </div>
                                    <div class="w-full h-px bg-[var(--grey)]"></div>
                                  </ng-container>
                                </ng-container>
                              </div>
                            </div>
                          </ng-container>

                          <!-- Visitas realizadas -->
                          <div *ngIf="item.visits && item.visits.length > 0" class="border-t border-[var(--grey)] pt-5">
                            <p class="text-[11px] uppercase font-bold tracking-widest text-[var(--dark-grey)] mb-3">{{ 'reservation.visitsCompleted' | translate }}</p>
                            <div class="flex flex-col gap-3">
                              <div *ngFor="let visit of item.visits" class="flex items-start gap-2 text-[13px] bg-[var(--light-grey)] p-3 rounded-lg">
                                <fa-icon [icon]="faQrcode" class="text-[var(--secondary)] mt-0.5"></fa-icon>
                                <div class="flex-1">
                                  <div class="flex flex-wrap items-baseline gap-x-2">
                                    <span class="font-semibold text-[var(--black)]">{{ visit.branch.brewery.name }}</span>
                                    <span class="text-[11px] text-[var(--dark-grey)]">{{ visit.branch.address }}</span>
                                  </div>
                                  <div class="flex flex-wrap items-center gap-2 mt-1">
                                    <span class="text-[11px] text-[var(--dark-grey)]">{{ visit.createdAt | date: 'dd MMM, HH:mm' }}</span>
                                    <span *ngIf="visit.product" class="text-[11px] font-bold text-[var(--secondary)]">
                                      · {{ visit.product.name }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </ng-container>

                        <!-- Disclaimer -->
                        <p class="text-[11px] text-[var(--dark-grey)] border-t border-[var(--grey)] pt-4">
                            <span class="font-semibold">{{ 'reservation.disclaimer' | translate }}</span>
                            {{ 'reservation.disclaimerFull' | translate }}
                        </p>

                    </div>
                </div>





            </div>
        </div>

      </div>
    </div>

  </div>
  